const credentialsTutorial = {
  module: 'credentials',
  moduleName: 'Credentials',
  steps: [
    { target: '.page-title', position: 'bottom', title: 'Credential Bank', description: 'Securely store SNMP, WMI, and other device credentials.' },
    { target: '.md-cred-stats', position: 'bottom', title: 'Credential Overview', description: 'See how many credentials you have by type.' },
    { target: '.page-header-actions .btn-primary', position: 'bottom', title: 'Add Credential', description: 'Store new device access credentials.' },
  ],
};
export default credentialsTutorial;
